import React, { useState, useEffect } from 'react'
import Snowfall from './Snowfall'
import SnowAccumulation from './StickySnowflakes'
import SantaSleigh from './SantaSleigh'

// Clé de storage
const STORAGE_KEY = 'CHRISTMAS_SETTINGS'
const DEFAULT_SETTINGS = {
  snowfall: true,
  snowAccumulation: true,
  santaSleigh: true,
}

// Helper pour lire les settings
const getSettings = () => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY)
    return stored ? JSON.parse(stored) : DEFAULT_SETTINGS
  } catch {
    return DEFAULT_SETTINGS
  }
}

const ChristmasDecorations = ({ activeTheme, forceActiveTheme }) => {
  const [christmasSettings, setChristmasSettings] = useState(getSettings)

  // Écoute les changements de localStorage (depuis d'autres composants)
  useEffect(() => {
    const handleStorageChange = (e) => {
      if (e.key === STORAGE_KEY) {
        setChristmasSettings(e.newValue ? JSON.parse(e.newValue) : DEFAULT_SETTINGS)
      }
    }

    // Écoute aussi un custom event pour les changements dans la même fenêtre
    const handleCustomChange = (e) => {
      setChristmasSettings(e.detail)
    }

    window.addEventListener('storage', handleStorageChange)
    window.addEventListener('christmas-settings-change', handleCustomChange)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('christmas-settings-change', handleCustomChange)
    }
  }, [])

  // Check if Christmas theme is active
  const isChristmasActive = activeTheme === 'christmas' || forceActiveTheme === 'christmas'

  if (!isChristmasActive) return null

  return (
    <>
      {/* Flocons qui tombent */}
      <Snowfall enabled={christmasSettings.snowfall} />
      
      {/* Neige accumulée sur les cards + sol */}
      <SnowAccumulation enabled={christmasSettings.snowAccumulation} />
      
      {/* Traîneau du Père Noël qui passe de temps en temps */}
      <SantaSleigh enabled={christmasSettings.santaSleigh} />
    </>
  )
}

export default ChristmasDecorations
